/// <reference types="@angular/localize" />

import 'codemirror/addon/display/fullscreen';
import 'codemirror/mode/sql/sql';

import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { ENVIRONMENT } from './environments/environment';

if (ENVIRONMENT.isProduction) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig).catch((error) => console.error(error));
